/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SecurityEventApiUser } from '../models/SecurityEventApiUser';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SecurityService {

    /**
     * Get list of users (for the company from token payload)
     * @returns SecurityEventApiUser Success
     * @throws ApiError
     */
    public static getSecurityEventApiListUsers(): CancelablePromise<Array<SecurityEventApiUser>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/security/users',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
